import { memo } from 'react'
import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  CircularProgress,
  Alert,
} from '@mui/material'

function DeleteProductDialog({
  open,
  product,
  loading,
  actionError,
  deleteError,
  showCascadeOption,
  onClose,
  onConfirm,
}) {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm">
      <DialogTitle sx={{ fontWeight: 600, bgcolor: deleteError ? '#ffebee' : '#fff3e0' }}>
        Delete Product?
      </DialogTitle>
      <DialogContent sx={{ pt: 2 }}>
        {deleteError ? (
          <>
            <Alert severity="warning" sx={{ mb: 2 }}>
              {deleteError}
            </Alert>
            {showCascadeOption && (
              <>
                <Typography variant="body1" sx={{ mb: 2 }}>
                  This product has inventory records. You can:
                </Typography>
                <Box component="ul" sx={{ pl: 2, mb: 2 }}>
                  <Typography component="li" variant="body2">
                    • Delete inventory records manually first, then delete the product
                  </Typography>
                  <Typography component="li" variant="body2">
                    • Use cascade delete to remove all related data automatically
                  </Typography>
                </Box>
                <Typography variant="body2" color="error" sx={{ fontWeight: 600 }}>
                  ⚠️ Cascade delete will permanently remove: inventory movements → inventory
                  records → product
                </Typography>
              </>
            )}
          </>
        ) : (
          <Typography>
            Are you sure you want to delete <strong>{product?.product_name}</strong>? This action
            cannot be undone.
          </Typography>
        )}
        {actionError && !deleteError && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {actionError}
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} disabled={loading} color="inherit">
          Cancel
        </Button>
        {showCascadeOption ? (
          <Button
            onClick={() => onConfirm(true)}
            variant="contained"
            disabled={loading}
            sx={{
              bgcolor: '#d32f2f',
              '&:hover': { bgcolor: '#b71c1c' },
              mr: 1,
            }}
          >
            {loading ? <CircularProgress size={20} /> : 'Cascade Delete'}
          </Button>
        ) : (
          <Button
            onClick={() => onConfirm(false)}
            variant="contained"
            disabled={loading}
            sx={{ bgcolor: '#d32f2f', '&:hover': { bgcolor: '#b71c1c' } }}
          >
            {loading ? <CircularProgress size={20} /> : 'Delete'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default memo(DeleteProductDialog)
